import * as request from "@/utils/request";
import { DefaultConfigs } from "@/common/js/constant";

const baseUrl = `${DefaultConfigs.publicConductAPIPath}`;

export type IContract = {
  stage: string;
  contractList: Array<{ code: string; name: string; url: string }>;
};

// 查询协议
export function queryContract(): Promise<IContract> {
  return request.post<IContract>(`${baseUrl}/conduct/contract/getListByStage`, {
    stage: "PRIVACY_CONTRACT",
  });
}
// 个人信息提交
export function userSubmit(params: {
  mobile: string;
  email: string;
  name: string;
  protocolName: string;
  protocolLink: string;
}): Promise<any> {
  return request.post<any>(`${baseUrl}/conduct/conduct/createUserRegistration`, params);
}
